import 'types/Shared/Locale'
import '../types'
type MenuItem = {
  title: string
  link: string
}
export const getShortcutsMenuList = (): ReadonlyArray<MenuItem> => {
  const menuList = [
    {
      title: 'Paintings',
      link: '/paintings',
    },
    {
      title: 'Abstract Art',
      link: '/all/abstract',
    },
    {
      title: 'Curated Deals',
      link: '/curated-deals',
    },
    {
      title: 'Oil Paintings',
      link: '/paintings/oil',
    },
    {
      title: 'Landscapes',
      link: '/all/landscape',
    },
    {
      title: 'Large Works',
      link: '/all/large?size=oversized',
    },
    {
      title: 'Acrylic Paintings',
      link: '/paintings/acrylic',
    },
    {
      title: 'Curated Collections',
      link: '/collections/featured',
    },
    {
      title: 'Modern Art',
      link: '/all/modern',
    },
    {
      title: 'Sculpture',
      link: '/sculpture',
    },
  ]
  return menuList
}
